var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-flex-column"},[_c('div',{staticClass:"sf-col sf-col-4"},[_c('sf-card',{staticClass:"p-0 card_bg"},[_c('search-bar',{attrs:{"scrId":_vm.scrId}})],1)],1),_c('div',{staticClass:"sf-col sf-col-20"},[_c('station-table',{attrs:{"scrId":_vm.scrId}})],1),_c('station-registration-popup',{attrs:{"scrId":_vm.scrId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }